import { render } from "./PlansPlanCard.vue?vue&type=template&id=ae0287b0&scoped=true&ts=true"
import script from "./PlansPlanCard.vue?vue&type=script&lang=ts"
export * from "./PlansPlanCard.vue?vue&type=script&lang=ts"

import "./PlansPlanCard.vue?vue&type=style&index=0&id=ae0287b0&lang=scss&scoped=true"

import exportComponent from "/opt/esim/admin-src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae0287b0"]])

export default __exports__